export default function DestinationEditController(
  $stateParams,
  $timeout,
  destinationService,
  NotificationService,
  sessionService,
  timezoneService,
  OPTIONS,
  DESTINATION_TYPES,
  POI_TYPES,
  HTTP_CODE,
) {
  const vm = this,
    GET_BY_ID_TIMEOUT = 1000;

  vm.isDestinationManager = sessionService.hasPermission(['DESTINATION_UPDATE']);
  vm.destinationId = $stateParams.destinationId;
  vm.retryOn404 = $stateParams.retryOn404;
  vm.citySizes = OPTIONS.destinationSubTypes;
  vm.destinationTypes = DESTINATION_TYPES;
  vm.POI_types = POI_TYPES;
  vm.timezones = null;
  vm.destination = null;
  vm.originalDestination = {};
  vm.destinationChildren = null;
  vm.isLoading = false;
  vm.childrenLoaded = false;
  vm.parentDestination = null;

  vm.init = init;
  vm.getTimezones = getTimezones;
  vm.getDestinationById = getDestinationById;
  vm.getDestinationChildren = getDestinationChildren;
  vm.updateDestination = updateDestination;
  vm.updateDestinationStatus = updateDestinationStatus;
  vm.updateBrowserUrl = updateBrowserUrl;
  vm.updateDestinationTree = updateDestinationTree;

  init();

  function init() {
    vm.getTimezones();
  }

  function getTimezones() {
    timezoneService
      .getAllTimezones()
      .then(res => {
        if (res && res.data) {
          vm.timezones = res.data;
        }
      })
      .finally(() => vm.getDestinationById(vm.destinationId));
  }

  function getDestinationById(destinationId) {
    if (!destinationId) {
      return;
    }

    enableLoading();
    destinationService
      .getDestinationByIdV2(destinationId)
      .then(res => {
        vm.destination = res.data;
        vm.originalDestination = angular.copy(vm.destination);
      })
      .catch(handleGetDestinationError)
      .finally(disableLoading);
  }

  function updateDestinationTree(newParentId) {
    vm.destination.tree.pop();
    vm.destination.tree.push(vm.destination.eligibleParents.filter(parent => parent.id === newParentId)[0]);
    vm.destination.parentId = newParentId;
    updateBrowserUrl();
  }

  function handleGetDestinationError(res) {
    if (res.status === HTTP_CODE.STATUS.BAD_REQUEST) {
      NotificationService.error('Invalid destination id');
    } else if (res.status === HTTP_CODE.STATUS.NOT_FOUND) {
      handleNotFound(vm.destinationId);
    }
  }

  function handleNotFound(destinationId) {
    if (vm.retryOn404) {
      vm.retryOn404 = false;
      $timeout(() => getDestinationById(destinationId), GET_BY_ID_TIMEOUT);
    } else {
      NotificationService.error('Destination not found');
    }
  }

  function getDestinationChildren() {
    if (!vm.destinationId) {
      return;
    }
    destinationService.getDestinationChildren(vm.destinationId).then(res => {
      vm.destinationChildren = res.data;
      vm.childrenLoaded = true;
    });
  }

  function updateDestination() {
    if (vm.isLoading || !vm.destination) {
      return;
    }

    enableLoading();
    const destinationDto = generateUpdateDestinationDto(vm.destination, vm.destination.status);

    destinationService
      .updateDestination(vm.destinationId, destinationDto)
      .then(() => NotificationService.success('Destination successfully updated'))
      .catch(showErrorMessage)
      .finally(disableLoading);
  }

  function updateDestinationStatus() {
    if (vm.isLoading || !vm.destination) {
      return;
    }

    enableLoading();
    const destinationDto = generateUpdateDestinationDto(vm.originalDestination, vm.destination.status);

    destinationService
      .updateDestination(vm.destinationId, destinationDto)
      .then(() => {
        const successMessage =
          'Destination ' + vm.destination.name + ' was ' + (vm.destination.status === 'active' ? 'enabled' : 'disabled');
        NotificationService.success(successMessage);
      })
      .catch(handleUpdateStatusError)
      .finally(disableLoading);
  }

  function handleUpdateStatusError(res) {
    showErrorMessage(res);
    vm.destination.status = vm.originalDestination.status;
  }

  function showErrorMessage(res) {
    const error = angular.isArray(res.data.errors) ? res.data.errors.shift() : res.data.errors;
    const errorMessage = error.message ? error.message : 'Destination status update failed';
    NotificationService.error(errorMessage);
  }

  function generateUpdateDestinationDto(destination, status) {
    return {
      id: destination.id,
      name: destination.name,
      parentId: destination.parentId,
      longitude: destination.longitude,
      latitude: destination.latitude,
      browserUrl: destination.browserUrl,
      destinationSubType: destination.destinationSubType,
      status: status,
      timezone: destination.timezone,
      radius: destination.radius || null,
      //TODO manage priority default value on API
      priority: destination.priority || vm.destination.destinationType.name === vm.destinationTypes.POI.name ? 0 : null,
      description: destination.description,
    };
  }

  function updateBrowserUrl() {
    vm.destination.browserUrl = destinationService.getBrowserUrlForDestination(
      vm.destination.name,
      vm.destination.destinationType,
      vm.destination.tree,
    );
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    return (vm.isLoading = false);
  }
}



// WEBPACK FOOTER //
// ./src/app/destinations/destination-edit.controller.js